import { defineStore } from 'pinia'
import { uuid } from 'vue3-uuid'
import AccountAPI from '../constants/account.api.uri.const'
import { APIClient } from '@/onenetwork/core/onenetwork.api.instant'
import { reactive } from 'vue'

export enum AccountDetailActionType {
  FETCHING = 'fetching',
  FETCHED = 'fetched',
  FETCH_FAILED = 'fetch_failed',
  CREATING = 'creating',
  CREATED = 'created',
  CREATE_FAILED = 'create_failed',
  UPDATING = 'updating',
  APPROVING = 'approving',
  APPROVED = 'approved',
  APPROVE_FAILED = 'approve_failed',
  REJECTING = 'rejecting',
  REJECTED = 'rejected',
  REJECT_FAILED = 'reject_failed',
}

interface AccountDetail {
  id: number
  code: string
  fullname: string
  phone: string
  email: string
  status: string
  profile_pic: string | null
  created_at: string
  updated_at: string
  role: object
  perms: string[]
}

interface AccountDetailState {
  accounts: {
    [key: string]: {
      action_type: AccountDetailActionType,
      approve_type: AccountDetailActionType,
      action_message: string,
      account: AccountDetail
    }
  }
}

export const useAccountDetailStore = defineStore('account.detail', {
  state: (): AccountDetailState => ({
    accounts: {},
  }),
  getters: {},
  actions: {
    async fetchAccountDetail(id: number, type: string) {
      return new Promise(async (resolve, reject) => {
        try {
          //fetching
          this.accounts[id] = {
            ...this.accounts[id],
            action_type: type === 'update' ? AccountDetailActionType.FETCHED : AccountDetailActionType.FETCHING,
          }
          const res: any = await APIClient.get(AccountAPI.account.detail.replace(':id', id.toString()))
          const { data } = res.data;

          this.accounts[id] = {
            action_type: AccountDetailActionType.FETCHED,
            action_message: res?.data?.message,
            account: data,
          }
          resolve(data);
        } catch (e) {
          console.log(e);

        }
      })
    },
    async setAccountDetail(id: number, account: Object) {
      this.accounts[id] = {
        action_type: AccountDetailActionType.FETCHED,
        action_message: '',
        account: {...this.accounts[id].account, ...account},
      }
    },
    async approveKyc(id: number) {
      try {
        //approving
        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: AccountDetailActionType.APPROVING,
        }
        const res: any = await APIClient.post(AccountAPI.kyc.approve.replace(':id', id.toString()))
        const { data } = res.data;

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: AccountDetailActionType.APPROVED,
          action_message: res?.data?.message,
          account: data,
        }
        return res;
      } catch (error) {

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: AccountDetailActionType.APPROVE_FAILED,
          action_message: '',
          account: this.accounts[id].account,
        }
        return error;
      }
    },
    async rejectKyc(id: number) {
      try {
        //rejecting
        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: AccountDetailActionType.REJECTING,
        }
        const res: any = await APIClient.post(AccountAPI.kyc.reject.replace(':id', id.toString()), {
          reason: 'Hệ Thống chưa xác thực được bạn',
        })
        const { data } = res.data;

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: AccountDetailActionType.REJECTED,
          action_message: res?.data?.message,
          account: data,
        }
        return res;
      } catch (error) {

        this.accounts[id] = {
          ...this.accounts[id],
          approve_type: AccountDetailActionType.REJECT_FAILED,
          action_message: '',
          account: this.accounts[id].account,
        }
        return error;
      }
    },
  },
})
